import { CertificationType } from 'src/common/enums/certification';

import { CertificationBannerContent } from './certification-banner.types';

export const certificationBannerContent: Record<CertificationType, CertificationBannerContent> = {
  [CertificationType.SAL1]: {
    title: 'The only defensive certification to get you hired!',
    titleSpan: ' defensive certification',
    description:
      'Become job-ready with a practical defensive certification designed by industry-expert, defensive security professionals.',
    learnMorePath: '/certification/security-analyst-level-1',
    segmentEventName: 'sal1-ad-click',
    segmentEventCategory: 'certification-release-banner',
    segmentEventAction: 'learn-more',
  },
  [CertificationType.PT1]: {
    title: 'The new Jr Pentester certification to get you hired',
    titleSpan: 'Jr Pentester',
    description:
      'Become job-ready with a practical offensive certification designed by industry-expert, offensive security professionals.',
    learnMorePath: '/certification/junior-penetration-tester',
    segmentEventName: 'pt1-ad-click',
    segmentEventCategory: 'certification-release-banner',
    segmentEventAction: 'learn-more',
  },
};
